import { l as b, n as D, h as L, f as ot, p as M, m as rt, s as st, _ as it } from "./Swup.modern-cdyLtNvW.js";
import { _ as Y } from "./__dev__-BPvTvNaV.js";
function $() {
  return $ = Object.assign ? Object.assign.bind() : function(o) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (o[n] = e[n]);
    }
    return o;
  }, $.apply(this, arguments);
}
const U = (o) => String(o).split(".").map((t) => String(parseInt(t || "0", 10))).concat(["0", "0"]).slice(0, 3).join(".");
let k = class {
  constructor() {
    this.isSwupPlugin = true, this.swup = void 0, this.version = void 0, this.requires = {}, this.handlersToUnregister = [];
  }
  mount() {
  }
  unmount() {
    this.handlersToUnregister.forEach((t) => t()), this.handlersToUnregister = [];
  }
  _beforeMount() {
    if (!this.name) throw new Error("You must define a name of plugin when creating a class.");
  }
  _afterUnmount() {
  }
  _checkRequirements() {
    return typeof this.requires != "object" || Object.entries(this.requires).forEach(([t, e]) => {
      if (!(function(n, i, r) {
        const s = (function(a, l) {
          var u;
          if (a === "swup") return (u = l.version) != null ? u : "";
          {
            var p;
            const h = l.findPlugin(a);
            return (p = h == null ? void 0 : h.version) != null ? p : "";
          }
        })(n, r);
        return !!s && ((a, l) => l.every((u) => {
          const [, p, h] = u.match(/^([\D]+)?(.*)$/) || [];
          var d, m;
          return ((c, f) => {
            const v = { "": (y) => y === 0, ">": (y) => y > 0, ">=": (y) => y >= 0, "<": (y) => y < 0, "<=": (y) => y <= 0 };
            return (v[f] || v[""])(c);
          })((m = h, d = U(d = a), m = U(m), d.localeCompare(m, void 0, { numeric: true })), p || ">=");
        }))(s, i);
      })(t, e = Array.isArray(e) ? e : [e], this.swup)) {
        const n = `${t} ${e.join(", ")}`;
        throw new Error(`Plugin version mismatch: ${this.name} requires ${n}`);
      }
    }), true;
  }
  on(t, e, n = {}) {
    var i;
    e = !(i = e).name.startsWith("bound ") || i.hasOwnProperty("prototype") ? e.bind(this) : e;
    const r = this.swup.hooks.on(t, e, n);
    return this.handlersToUnregister.push(r), r;
  }
  once(t, e, n = {}) {
    return this.on(t, e, $({}, n, { once: true }));
  }
  before(t, e, n = {}) {
    return this.on(t, e, $({}, n, { before: true }));
  }
  replace(t, e, n = {}) {
    return this.on(t, e, $({}, n, { replace: true }));
  }
  off(t, e) {
    return this.swup.hooks.off(t, e);
  }
};
(function() {
  if (!(typeof window > "u" || typeof document > "u" || typeof HTMLElement > "u")) {
    var o = false;
    try {
      var t = document.createElement("div");
      t.addEventListener("focus", function(r) {
        r.preventDefault(), r.stopPropagation();
      }, true), t.focus(Object.defineProperty({}, "preventScroll", { get: function() {
        if (navigator && typeof navigator.userAgent < "u" && navigator.userAgent && navigator.userAgent.match(/Edge\/1[7-8]/)) return o = false;
        o = true;
      } }));
    } catch {
    }
    if (HTMLElement.prototype.nativeFocus === void 0 && !o) {
      HTMLElement.prototype.nativeFocus = HTMLElement.prototype.focus;
      var e = function(r) {
        for (var s = r.parentNode, a = [], l = document.scrollingElement || document.documentElement; s && s !== l; ) (s.offsetHeight < s.scrollHeight || s.offsetWidth < s.scrollWidth) && a.push([s, s.scrollTop, s.scrollLeft]), s = s.parentNode;
        return s = l, a.push([s, s.scrollTop, s.scrollLeft]), a;
      }, n = function(r) {
        for (var s = 0; s < r.length; s++) r[s][0].scrollTop = r[s][1], r[s][0].scrollLeft = r[s][2];
        r = [];
      }, i = function(r) {
        if (r && r.preventScroll) {
          var s = e(this);
          if (typeof setTimeout == "function") {
            var a = this;
            setTimeout(function() {
              a.nativeFocus(), n(s);
            }, 0);
          } else this.nativeFocus(), n(s);
        } else this.nativeFocus();
      };
      HTMLElement.prototype.focus = i;
    }
  }
})();
function R() {
  return R = Object.assign ? Object.assign.bind() : function(o) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (o[n] = e[n]);
    }
    return o;
  }, R.apply(this, arguments);
}
function B(o, t) {
  return Object.keys(t).reduce((e, n) => e.replace(`{${n}}`, t[n] || ""), o || "");
}
let at = class {
  constructor() {
    var t;
    this.id = "swup-announcer", this.style = "position:absolute;top:0;left:0;clip:rect(0 0 0 0);clip-path:inset(50%);overflow:hidden;white-space:nowrap;word-wrap:normal;width:1px;height:1px;", this.region = void 0, this.region = (t = this.getRegion()) != null ? t : this.createRegion();
  }
  getRegion() {
    return document.getElementById(this.id);
  }
  createRegion() {
    const t = (function(e) {
      const n = document.createElement("template");
      return n.innerHTML = e, n.content.children[0];
    })(`<p aria-live="assertive" aria-atomic="true" id="${this.id}" style="${this.style}"></p>`);
    return document.body.appendChild(t), t;
  }
  announce(t, e = 0) {
    return new Promise((n) => {
      setTimeout(() => {
        this.region.textContent === t && (t = `${t}.`), this.region.textContent = "", this.region.textContent = t, n();
      }, e);
    });
  }
};
function N(o) {
  let t;
  if (t = typeof o == "string" ? document.querySelector(o) : o, !(t instanceof HTMLElement)) return;
  const e = t.getAttribute("tabindex");
  t.setAttribute("tabindex", "-1"), t.focus({ preventScroll: true }), e !== null && t.setAttribute("tabindex", e);
}
let lt = class extends k {
  constructor(t = {}) {
    super(), this.name = "SwupA11yPlugin", this.requires = { swup: ">=4" }, this.defaults = { headingSelector: "h1", respectReducedMotion: true, autofocus: false, announcements: { visit: "Navigated to: {title}", url: "New page at {url}" } }, this.options = void 0, this.announcer = void 0, this.announcementDelay = 100, this.rootSelector = "body", this.handleAnchorScroll = (e, { hash: n }) => {
      const i = this.swup.getAnchorElement(n);
      i instanceof HTMLElement && N(i);
    }, this.options = R({}, this.defaults, t), this.announcer = new at();
  }
  mount() {
    this.swup.hooks.create("content:announce"), this.swup.hooks.create("content:focus"), this.before("visit:start", this.prepareVisit), this.on("visit:start", this.markAsBusy), this.on("visit:end", this.unmarkAsBusy), this.on("visit:end", this.focusContent), this.on("visit:end", this.announceContent), this.on("scroll:anchor", this.handleAnchorScroll), this.before("visit:start", this.disableAnimations), this.before("link:self", this.disableAnimations), this.before("link:anchor", this.disableAnimations), this.swup.announce = this.announce.bind(this);
  }
  unmount() {
    this.swup.announce = void 0;
  }
  async announce(t) {
    await this.announcer.announce(t);
  }
  markAsBusy() {
    document.documentElement.setAttribute("aria-busy", "true");
  }
  unmarkAsBusy() {
    document.documentElement.removeAttribute("aria-busy");
  }
  prepareVisit(t) {
    t.a11y = { announce: void 0, focus: this.rootSelector };
  }
  announceContent(t) {
    this.swup.hooks.callSync("content:announce", t, void 0, (e) => {
      e.a11y.announce === void 0 && (e.a11y.announce = this.getPageAnnouncement()), e.a11y.announce && this.announcer.announce(e.a11y.announce, this.announcementDelay);
    });
  }
  focusContent(t) {
    this.swup.hooks.callSync("content:focus", t, void 0, (e) => {
      e.a11y.focus && (this.options.autofocus && (function() {
        const n = (function() {
          const i = document.querySelector("body [autofocus]");
          if (i && !i.closest('[inert], [aria-disabled], [aria-hidden="true"]')) return i;
        })();
        return !!n && (n !== document.activeElement && n.focus(), true);
      })() === true || N(e.a11y.focus));
    });
  }
  getPageAnnouncement() {
    const { headingSelector: t, announcements: e } = this.options;
    return (function({ headingSelector: n = "h1", announcements: i = {} }) {
      var r, s;
      const a = document.documentElement.lang || "*", { href: l, url: u, pathname: p } = b.fromUrl(window.location.href), h = (r = (s = i[a]) != null ? s : i["*"]) != null ? r : i;
      if (typeof h != "object") return;
      const d = document.querySelector(n);
      d || console.warn(`SwupA11yPlugin: No main heading (${n}) found on new page`);
      const m = (d == null ? void 0 : d.getAttribute("aria-label")) || (d == null ? void 0 : d.textContent) || document.title || B(h.url, { href: l, url: u, path: p });
      return B(h.visit, { title: m, href: l, url: u, path: p });
    })({ headingSelector: t, announcements: e });
  }
  disableAnimations(t) {
    this.options.respectReducedMotion && window.matchMedia("(prefers-reduced-motion: reduce)").matches && (t.animation.animate = false, t.scroll.animate = false);
  }
};
function _() {
  return _ = Object.assign ? Object.assign.bind() : function(o) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e) ({}).hasOwnProperty.call(e, n) && (o[n] = e[n]);
    }
    return o;
  }, _.apply(null, arguments);
}
function W() {
  return window.matchMedia("(hover: hover)").matches;
}
function P(o) {
  return !!o && (o instanceof HTMLAnchorElement || o instanceof SVGAElement);
}
const G = window.requestIdleCallback || ((o) => setTimeout(o, 1)), ut = ["preloadVisibleLinks"];
let ct = class extends k {
  constructor(t = {}) {
    var e;
    super(), e = this, this.name = "SwupPreloadPlugin", this.requires = { swup: ">=4.5" }, this.defaults = { throttle: 5, preloadInitialPage: true, preloadHoveredLinks: true, preloadVisibleLinks: { enabled: false, threshold: 0.2, delay: 500, containers: ["body"], ignore: () => false } }, this.options = void 0, this.queue = void 0, this.preloadObserver = void 0, this.preloadPromises = /* @__PURE__ */ new Map(), this.mouseEnterDelegate = void 0, this.touchStartDelegate = void 0, this.focusDelegate = void 0, this.onPageLoad = (r, s, a) => {
      const { url: l } = r.to;
      return l && this.preloadPromises.has(l) ? this.preloadPromises.get(l) : a(r, s);
    }, this.onMouseEnter = async function(r) {
      if (r.target !== r.delegateTarget || !W()) return;
      const s = r.delegateTarget;
      if (!P(s)) return;
      const { url: a, hash: l } = b.fromElement(s), u = e.swup.createVisit({ to: a, hash: l, el: s, event: r });
      e.swup.hooks.callSync("link:hover", u, { el: s, event: r }), e.preload(s, { priority: true });
    }, this.onTouchStart = (r) => {
      if (W()) return;
      const s = r.delegateTarget;
      P(s) && this.preload(s, { priority: true });
    }, this.onFocus = (r) => {
      const s = r.delegateTarget;
      P(s) && this.preload(s, { priority: true });
    };
    const { preloadVisibleLinks: n } = t, i = (function(r, s) {
      if (r == null) return {};
      var a = {};
      for (var l in r) if ({}.hasOwnProperty.call(r, l)) {
        if (s.includes(l)) continue;
        a[l] = r[l];
      }
      return a;
    })(t, ut);
    this.options = _({}, this.defaults, i), typeof n == "object" ? this.options.preloadVisibleLinks = _({}, this.options.preloadVisibleLinks, { enabled: true }, n) : this.options.preloadVisibleLinks.enabled = !!n, this.preload = this.preload.bind(this), this.queue = /* @__PURE__ */ (function(r = 1) {
      const s = [], a = [];
      let l = 0, u = 0;
      function p() {
        u < r && l > 0 && ((a.shift() || s.shift() || (() => {
        }))(), l--, u++);
      }
      return { add: function(h, d = false) {
        if (h.__queued) {
          if (!d) return;
          {
            const m = s.indexOf(h);
            if (m >= 0) {
              const c = s.splice(m, 1);
              l -= c.length;
            }
          }
        }
        h.__queued = true, (d ? a : s).push(h), l++, l <= 1 && p();
      }, next: function() {
        u--, p();
      } };
    })(this.options.throttle);
  }
  mount() {
    const t = this.swup;
    t.options.cache ? (t.hooks.create("page:preload"), t.hooks.create("link:hover"), t.preload = this.preload, t.preloadLinks = this.preloadLinks, this.replace("page:load", this.onPageLoad), this.preloadLinks(), this.on("page:view", () => this.preloadLinks()), this.options.preloadVisibleLinks.enabled && (this.preloadVisibleLinks(), this.on("page:view", () => this.preloadVisibleLinks())), this.options.preloadHoveredLinks && this.preloadLinksOnAttention(), this.options.preloadInitialPage && this.preload(D())) : console.warn("SwupPreloadPlugin: swup cache needs to be enabled for preloading");
  }
  unmount() {
    var t, e, n;
    this.swup.preload = void 0, this.swup.preloadLinks = void 0, this.preloadPromises.clear(), (t = this.mouseEnterDelegate) == null || t.destroy(), (e = this.touchStartDelegate) == null || e.destroy(), (n = this.focusDelegate) == null || n.destroy(), this.stopPreloadingVisibleLinks();
  }
  async preload(t, e = {}) {
    var n;
    let i, r;
    const s = (n = e.priority) != null && n;
    if (Array.isArray(t)) return Promise.all(t.map((l) => this.preload(l)));
    if (P(t)) r = t, { href: i } = b.fromElement(t);
    else {
      if (typeof t != "string") return;
      i = t;
    }
    if (!i) return;
    if (this.swup.cache.has(i)) return this.swup.cache.get(i);
    if (this.preloadPromises.has(i)) return this.preloadPromises.get(i);
    if (!this.shouldPreload(i, { el: r })) return;
    const a = new Promise((l) => {
      this.queue.add(() => {
        this.performPreload(i).catch(() => {
        }).then((u) => l(u)).finally(() => {
          this.queue.next(), this.preloadPromises.delete(i);
        });
      }, s);
    });
    return this.preloadPromises.set(i, a), a;
  }
  preloadLinks() {
    G(() => {
      Array.from(document.querySelectorAll("a[data-swup-preload], [data-swup-preload-all] a")).forEach((t) => this.preload(t));
    });
  }
  preloadLinksOnAttention() {
    const { swup: t } = this, { linkSelector: e } = t.options, n = { passive: true, capture: true };
    this.mouseEnterDelegate = t.delegateEvent(e, "mouseenter", this.onMouseEnter, n), this.touchStartDelegate = t.delegateEvent(e, "touchstart", this.onTouchStart, n), this.focusDelegate = t.delegateEvent(e, "focus", this.onFocus, n);
  }
  preloadVisibleLinks() {
    if (this.preloadObserver) return void this.preloadObserver.update();
    const { threshold: t, delay: e, containers: n } = this.options.preloadVisibleLinks;
    this.preloadObserver = (function({ threshold: i, delay: r, containers: s, callback: a, filter: l }) {
      const u = /* @__PURE__ */ new Map(), p = new IntersectionObserver((c) => {
        c.forEach((f) => {
          f.isIntersecting ? h(f.target) : d(f.target);
        });
      }, { threshold: i }), h = (c) => {
        var f;
        const { href: v } = b.fromElement(c), y = (f = u.get(v)) != null ? f : /* @__PURE__ */ new Set();
        u.set(v, y), y.add(c), setTimeout(() => {
          const A = u.get(v);
          A != null && A.size && (a(c), p.unobserve(c), A.delete(c));
        }, r);
      }, d = (c) => {
        var f;
        const { href: v } = b.fromElement(c);
        (f = u.get(v)) == null || f.delete(c);
      }, m = () => {
        G(() => {
          const c = s.map((f) => `${f} a[*|href]`).join(", ");
          Array.from(document.querySelectorAll(c)).filter((f) => l(f)).forEach((f) => p.observe(f));
        });
      };
      return { start: () => m(), stop: () => p.disconnect(), update: () => (u.clear(), m()) };
    })({ threshold: t, delay: e, containers: n, callback: (i) => this.preload(i), filter: (i) => {
      if (this.options.preloadVisibleLinks.ignore(i) || !i.matches(this.swup.options.linkSelector)) return false;
      const { href: r } = b.fromElement(i);
      return this.shouldPreload(r, { el: i });
    } }), this.preloadObserver.start();
  }
  stopPreloadingVisibleLinks() {
    this.preloadObserver && this.preloadObserver.stop();
  }
  shouldPreload(t, { el: e } = {}) {
    const { url: n, href: i } = b.fromUrl(t);
    return !(!(function() {
      if (navigator.connection) {
        var r;
        if (navigator.connection.saveData || (r = navigator.connection.effectiveType) != null && r.endsWith("2g")) return false;
      }
      return true;
    })() || this.swup.cache.has(n) || this.preloadPromises.has(n) || this.swup.shouldIgnoreVisit(i, { el: e }) || e && this.swup.resolveUrl(n) === this.swup.resolveUrl(D()));
  }
  async performPreload(t) {
    var e = this;
    const { url: n } = b.fromUrl(t), i = this.swup.createVisit({ to: n });
    return await this.swup.hooks.call("page:preload", i, { url: n }, async function(s, a) {
      return a.page = await e.swup.fetchPage(t, { visit: s }), a.page;
    });
  }
};
function T() {
  return T = Object.assign ? Object.assign.bind() : function(o) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (o[n] = e[n]);
    }
    return o;
  }, T.apply(this, arguments);
}
const ht = { from: "(.*)", to: "(.*)", out: (o) => o(), in: (o) => o() };
let pt = class extends k {
  constructor(t) {
    var e, n;
    super(), e = this, this.name = "SwupJsPlugin", this.requires = { swup: ">=4" }, this.defaults = { animations: [], matchOptions: {} }, this.options = void 0, this.animations = [], this.awaitOutAnimation = async function(i, { skip: r }) {
      r || await e.findAndRunAnimation(i, "out");
    }, this.awaitInAnimation = async function(i, { skip: r }) {
      r || await e.findAndRunAnimation(i, "in");
    }, Array.isArray(t) && (t = { animations: t }), this.options = T({}, this.defaults, t), this.options.animations.push(ht), this.animations = (n = this.options.matchOptions, this.options.animations.map((i) => (function(r, s) {
      return T({}, r, { matchesFrom: L(r.from, s), matchesTo: L(r.to, s) });
    })(i, n)));
  }
  mount() {
    this.replace("animation:out:await", this.awaitOutAnimation, { priority: -1 }), this.replace("animation:in:await", this.awaitInAnimation, { priority: -1 });
  }
  async findAndRunAnimation(t, e) {
    const n = (function(i, r) {
      return (function(s, a, l, u) {
        let p = 0;
        return s.reduceRight((d, m) => {
          const c = (function(f, v, y, A) {
            let E = 0;
            const x = f.matchesFrom(v);
            return x && (E += 1), f.matchesTo(y) && (E += 1), x && f.to === A && (E += 2), E;
          })(m, a, l, u);
          return c >= p ? (p = c, m) : d;
        }, null);
      })(i, r.from.url, r.to.url, r.animation.name);
    })(this.animations, t);
    if (n) {
      const i = (function(r, s, a) {
        const l = r.matchesFrom(s.from.url), u = r.matchesTo(s.to.url);
        return { visit: s, direction: a, from: { url: s.from.url, pattern: r.from, params: l ? l.params : {} }, to: { url: s.to.url, pattern: r.to, params: u ? u.params : {} } };
      })(n, t, e);
      await (function(r, s) {
        const { direction: a } = s, l = r[a];
        return l ? new Promise((u) => {
          const p = l(() => u(), s);
          ot(p) && p.then(u);
        }) : (console.warn(`Missing animation function for '${a}' phase`), Promise.resolve());
      })(n, i);
    }
  }
};
function I() {
  return I = Object.assign ? Object.assign.bind() : function(o) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (o[n] = e[n]);
    }
    return o;
  }, I.apply(this, arguments);
}
class dt extends k {
  constructor(t = {}) {
    super(), this.name = "SwupDebugPlugin", this.requires = { swup: ">=4" }, this.defaults = { globalInstance: false }, this.options = void 0, this.originalSwupLog = void 0, this.originalSwupHookCall = void 0, this.originalSwupHookCallSync = void 0, this.callHook = (e, n, ...i) => (this.logHook(e, n), this.originalSwupHookCall(e, n, ...i)), this.callHookSync = (e, n, ...i) => (this.logHook(e, n), this.originalSwupHookCallSync(e, n, ...i)), this.options = I({}, this.defaults, t);
  }
  mount() {
    this.setLogImplementation(), this.setGlobalInstance(), this.proxyHooksThroughConsole(), this.checkDocumentTitle(), this.checkContainers(), this.checkAnimationSelector();
  }
  unmount() {
    super.unmount(), this.restoreLogImplementation(), this.restoreHooksImplementation(), this.unsetGlobalInstance();
  }
  setLogImplementation() {
    this.originalSwupLog = this.swup.log, this.swup.log = this.log;
  }
  restoreLogImplementation() {
    this.swup.log = this.originalSwupLog;
  }
  proxyHooksThroughConsole() {
    this.originalSwupHookCall = this.swup.hooks.call.bind(this.swup.hooks), this.originalSwupHookCallSync = this.swup.hooks.callSync.bind(this.swup.hooks), this.swup.hooks.call = this.callHook.bind(this), this.swup.hooks.callSync = this.callHookSync.bind(this);
  }
  restoreHooksImplementation() {
    this.swup.hooks.call = this.originalSwupHookCall, this.swup.hooks.callSync = this.originalSwupHookCallSync;
  }
  setGlobalInstance() {
    this.options.globalInstance && (window.swup = this.swup);
  }
  unsetGlobalInstance() {
    this.options.globalInstance && (window.swup = void 0);
  }
  checkDocumentTitle() {
    M("title") || this.error("Document is missing a title tag. It is required on every page.");
  }
  checkContainers() {
    for (const t of this.swup.options.containers) {
      const e = rt(t);
      e.length || this.error(`Container \`${t}\` is missing on the page.`), e.length > 1 && this.error(`Container \`${t}\` matches multiple elements.`), e.some((n) => !n.matches("body *")) && this.error(`Container \`${t}\` is not supported. It must be a child of the body tag.`);
    }
  }
  checkAnimationSelector() {
    const { animationSelector: t } = this.swup.options;
    t && (this.swup.options.containers.map((e) => M(e)).filter((e) => e == null ? void 0 : e.matches(t)).length || this.warn(`No container matches the animation selector \`${t}\`.`));
  }
  logHook(t, e) {
    console.groupCollapsed("%cswup:%c" + t, "color: #343434", "color: #009ACD"), console.log(e), console.groupEnd();
  }
  log(t, e) {
    if (e) {
      console.groupCollapsed(t);
      for (let n in e) console.log(e[n]);
      console.groupEnd();
    } else console.log(t + "%c", "color: #009ACD");
  }
  warn(t) {
    console.warn(`[swup debug plugin] ${t}`);
  }
  error(t) {
    console.error(`[swup debug plugin] ${t}`);
  }
}
function S() {
  return S = Object.assign ? Object.assign.bind() : function(o) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e) ({}).hasOwnProperty.call(e, n) && (o[n] = e[n]);
    }
    return o;
  }, S.apply(null, arguments);
}
window.process || (window.process = {}), window.process.env || (window.process.env = {});
const K = ["test"].includes("production"), g = ["development", "test"].includes("production"), X = (o, t, e) => o == null ? o : `\x1B[${t}m${String(o)}\x1B[${e}m`, C = (o) => K ? o : `\u{1F9E9} ${((t) => X(t, 1, 22))(o)}`, w = (o) => K ? o : ((t) => X(t, 94, 39))(o);
class ft {
  log(...t) {
    const e = t.shift();
    console.log(C(e), ...t);
  }
  warn(...t) {
    const e = t.shift();
    console.warn(C(e), ...t);
  }
  error(...t) {
    const e = t.shift();
    console.error(C(e), ...t);
  }
  logIf(t, ...e) {
    t && this.log(...e);
  }
  warnIf(t, ...e) {
    t && this.warn(...e);
  }
  errorIf(t, ...e) {
    t && this.error(...e);
  }
}
const Z = (o) => {
  (function({ parsedRules: t, swup: e, logger: n }) {
    const i = e.getCurrentUrl();
    t.filter((r) => r.matchesFrom(i) || r.matchesTo(i)).forEach((r) => {
      r.containers.forEach((s) => {
        const a = q(`${s}:not([data-swup-fragment])`, e);
        if (!a) return;
        const l = a.getAttribute("data-swup-fragment-url");
        l && g && (n == null ? void 0 : n.log(`fragment url ${w(l)} for ${w(s)} provided by server`));
        const { url: u } = b.fromUrl(l || i);
        a.setAttribute("data-swup-fragment", ""), a.__swupFragment = { url: u, selector: s };
      });
    });
  })(o), (function({ logger: t, swup: e }) {
    const n = "data-swup-link-to-fragment";
    document.querySelectorAll(`a[${n}]`).forEach((i) => {
      var r, s;
      const a = (r = i.getAttribute(n)) == null ? void 0 : r.trim();
      if (!a) return void (g && (t == null || t.warn(`[${n}] needs to contain a valid fragment selector`)));
      const l = a.trim().split(",").map((h) => h.trim()), u = (function(h, d) {
        const m = h.map((c) => c.trim());
        for (const c of m) {
          const f = q(c, d);
          if (f) return f;
        }
      })(l, e);
      if (!u) {
        if (g) {
          const h = l.length > 1 ? "are" : "is", d = w(l.join(", "));
          t == null ? void 0 : t.log(`ignoring ${w(`[${n}="${a}"]`)} as ${d} ${h} missing`);
        }
        return;
      }
      const p = (s = u.__swupFragment) == null ? void 0 : s.url;
      p ? (F(p, e.getCurrentUrl()) && g && (t == null ? void 0 : t.warn(`The fragment URL of #${u.id} is identical to the current URL. This could mean that [data-swup-fragment-url] needs to be provided by the server.`)), i.href = p) : g && (t == null ? void 0 : t.warn(`no fragment infos found on #${u.id}`));
    });
  })(o), (function({ logger: t }) {
    document.querySelectorAll("dialog[data-swup-fragment][open]").forEach((e) => {
      e.__swupFragment ? e.__swupFragment.modalShown || (e.__swupFragment.modalShown = true, e.removeAttribute("open"), e.showModal == null || e.showModal(), e.addEventListener("keydown", (n) => n.key === "Escape" && n.preventDefault())) : g && (t == null ? void 0 : t.warn("fragment properties missing on element:", e));
    });
  })(o);
}, V = (o, t) => {
  var e;
  const n = (e = o.__swupFragment) == null ? void 0 : e.url;
  return !!n && F(n, t);
}, F = (o, t) => z(o) === z(t), z = (o) => {
  if (!o.trim()) return o;
  const t = b.fromUrl(o);
  return t.searchParams.sort(), t.pathname.replace(/\/+$/g, "") + t.search;
}, tt = (o) => {
  const t = o.from.url, e = o.to.url;
  if (t && e) return { from: t, to: e };
}, j = (o, t) => {
  if (o == null || !o.name) return;
  const { name: e, containers: n } = o;
  n.forEach((i) => {
    var r;
    (r = document.querySelector(i)) == null || r.classList.toggle(`to-${e}`, t);
  });
}, et = (o, t, e) => t.find((n) => n.matches(o, e));
function nt(o) {
  return !!o && o.containers.every((t) => {
    var e;
    return ((e = document.querySelector(t)) == null || (e = e.tagName) == null ? void 0 : e.toLowerCase()) === "template";
  });
}
function q(o, t) {
  for (const e of t.options.containers) {
    const n = document.querySelector(e);
    if (n != null && n.matches(o)) return n;
    const i = n == null ? void 0 : n.querySelector(o);
    if (i) return i;
  }
}
function J(o) {
  if (!Array.isArray(o)) throw new Error("cloneRules() expects an array of rules");
  return o.map((t) => S({}, t, { from: Array.isArray(t.from) ? [...t.from] : t.from, to: Array.isArray(t.to) ? [...t.to] : t.to, containers: [...t.containers] }));
}
class mt {
  constructor(t) {
    var e, n;
    this.matchesFrom = void 0, this.matchesTo = void 0, this.swup = void 0, this.from = void 0, this.to = void 0, this.containers = void 0, this.name = void 0, this.scroll = false, this.focus = void 0, this.logger = void 0, this.if = () => true, this.swup = t.swup, this.logger = t.logger, this.from = t.from || "", this.to = t.to || "", t.name && (this.name = st(t.name)), t.scroll !== void 0 && (this.scroll = t.scroll), t.focus !== void 0 && (this.focus = t.focus), typeof t.if == "function" && (this.if = t.if), this.containers = this.parseContainers(t.containers), g && ((e = this.logger) == null || e.errorIf(!this.to, "Every fragment rule must contain a 'to' path", this), (n = this.logger) == null || n.errorIf(!this.from, "Every fragment rule must contain a 'from' path", this)), this.matchesFrom = L(this.from), this.matchesTo = L(this.to);
  }
  parseContainers(t) {
    var e, n;
    return Array.isArray(t) && t.length ? (n = t.map((i) => i.trim()), [...new Set(n)]).filter((i) => {
      var r;
      const s = this.validateSelector(i);
      return (r = this.logger) == null || r.errorIf(s instanceof Error, s), s === true;
    }) : (g && ((e = this.logger) == null || e.error("Every fragment rule must contain an array of containers", this.getDebugInfo())), []);
  }
  validateSelector(t) {
    return t.startsWith("#") ? !t.match(/\s|>/) || new Error(`fragment selectors must not be nested: ${t}`) : new Error(`fragment selectors must be IDs: ${t}`);
  }
  getDebugInfo() {
    const { from: t, to: e, containers: n } = this;
    return { from: String(t), to: String(e), containers: String(n) };
  }
  matches(t, e) {
    var n;
    if (!this.if(e)) return g && ((n = this.logger) == null || n.log("ignoring fragment rule due to custom rule.if:", this)), false;
    const { url: i } = b.fromUrl(t.from), { url: r } = b.fromUrl(t.to);
    if (!this.matchesFrom(i) || !this.matchesTo(r)) return false;
    for (const a of this.containers) {
      const l = this.validateFragmentSelectorForMatch(a);
      var s;
      if (l instanceof Error) return g && ((s = this.logger) == null || s.error(l, this.getDebugInfo())), false;
    }
    return true;
  }
  validateFragmentSelectorForMatch(t) {
    return document.querySelector(t) ? !!q(t, this.swup) || new Error(`skipping rule since ${w(t)} is outside of swup's default containers`) : new Error(`skipping rule since ${w(t)} doesn't exist in the current document`);
  }
}
const gt = function(o) {
  const t = tt(o);
  t && et(t, this.parsedRules, o) && (o.scroll.reset = false);
}, wt = async function(o) {
  const t = tt(o);
  if (!t) return;
  const e = this.getFragmentVisit(t, o);
  if (!e) return;
  var n;
  o.fragmentVisit = e, g && ((n = this.logger) == null || n.log(`fragment visit: ${w(o.fragmentVisit.containers.join(", "))}`)), o.scroll = (function(s, a) {
    const l = a.scroll;
    let u = s.scroll;
    return typeof u == "function" && (u = u(a)), typeof u == "boolean" ? S({}, l, { reset: u }) : typeof u != "string" || l.target ? l : S({}, l, { target: u });
  })(e, o);
  const i = o.a11y;
  var r;
  e.focus !== void 0 && (g && ((r = this.logger) == null || r.errorIf(!i, "Can't set visit.a11y.focus. Is @swup/a11y-plugin installed?")), i && (i.focus = e.focus)), o.animation.scope = o.fragmentVisit.containers, o.containers = o.fragmentVisit.containers, o.animation.selector = o.fragmentVisit.containers.join(","), j(e, true);
}, vt = function(o, t) {
  var e, n;
  o.fragmentVisit && nt(o.fragmentVisit) && (g && ((e = this.logger) == null || e.log(`${w("out")}-animation skipped for ${w((n = o.fragmentVisit) == null ? void 0 : n.containers.toString())}`)), t.skip = true);
}, yt = function(o, t) {
  var e, n;
  o.fragmentVisit && nt(o.fragmentVisit) && (g && ((e = this.logger) == null || e.log(`${w("in")}-animation skipped for ${w((n = o.fragmentVisit) == null ? void 0 : n.containers.toString())}`)), t.skip = true);
}, bt = function(o, t) {
  var e;
  if (o.trigger.el || !o.to.url) return;
  const n = this.swup.cache.get(o.to.url);
  n && n.fragmentHtml && (o.to.document = new DOMParser().parseFromString(n.fragmentHtml, "text/html"), o.to.html = n.fragmentHtml, g && ((e = this.logger) == null || e.log(`fragment cache used for ${w(o.to.url)}`)));
}, St = function(o) {
  j(o.fragmentVisit, true), Z(this), (({ swup: t, logger: e }) => {
    const n = t.getCurrentUrl(), i = t.cache, r = i.get(n);
    if (!r) return;
    const s = new DOMParser().parseFromString(r.html, "text/html"), a = [], l = Array.from(document.querySelectorAll("[data-swup-fragment]")).filter((u) => !u.matches("template") && !V(u, n));
    l.length && (t.options.cache ? (l.forEach((u) => {
      var p, h;
      if (u.querySelector("[data-swup-fragment]") != null) return;
      const d = (p = u.__swupFragment) == null ? void 0 : p.url;
      if (!d) return void (g && (e == null || e.warn("no fragment url found:", u)));
      const m = (h = u.__swupFragment) == null ? void 0 : h.selector;
      if (!m) return void (g && (e == null || e.warn("no fragment selector found:", u)));
      const c = i.get(d);
      if (!c) return;
      const f = s.querySelector(m);
      if (!f) return;
      const v = new DOMParser().parseFromString(c.html, "text/html").querySelector(m);
      v && (v.setAttribute("data-swup-fragment-url", d), f.replaceWith(v), a.push(u));
    }), a.length && (i.update(n, { fragmentHtml: s.documentElement.outerHTML }), a.forEach((u) => {
      var p, h;
      const d = ((p = u.__swupFragment) == null ? void 0 : p.url) || "", m = ((h = u.__swupFragment) == null ? void 0 : h.selector) || "";
      g && (e == null ? void 0 : e.log(`updated cache with ${w(m)} from ${w(d)}`));
    }))) : g && (e == null ? void 0 : e.warn("can't cache foreign fragment elements without swup's cache")));
  })(this);
}, kt = function(o) {
  j(o.fragmentVisit, false);
};
class At extends k {
  get parsedRules() {
    return this._parsedRules;
  }
  constructor(t) {
    super(), this.name = "SwupFragmentPlugin", this.requires = { swup: ">=4.6" }, this._rawRules = [], this._parsedRules = [], this.options = void 0, this.defaults = { rules: [], debug: false }, this.logger = void 0, this.options = S({}, this.defaults, t);
  }
  mount() {
    const t = this.swup;
    var e;
    this.setRules(this.options.rules), g && this.options.debug && (this.logger = new ft()), this.before("link:self", gt), this.on("visit:start", wt), this.before("animation:out:await", vt), this.before("animation:in:await", yt), this.before("content:replace", bt), this.on("content:replace", St), this.on("visit:end", kt), g && ((e = this.logger) == null || e.warnIf(!t.options.cache, "fragment caching will only work with swup's cache being active")), Z(this);
  }
  unmount() {
    super.unmount(), document.querySelectorAll("[data-swup-fragment]").forEach((t) => {
      t.removeAttribute("data-swup-fragment-url"), delete t.__swupFragment;
    });
  }
  setRules(t) {
    var e;
    this._rawRules = J(t), this._parsedRules = t.map((n) => this.parseRule(n)), g && ((e = this.logger) == null || e.log("Updated fragment rules", this.getRules()));
  }
  getRules() {
    return J(this._rawRules);
  }
  prependRule(t) {
    this.setRules([t, ...this.getRules()]);
  }
  appendRule(t) {
    this.setRules([...this.getRules(), t]);
  }
  parseRule(t) {
    return new mt(S({}, t, { logger: this.logger, swup: this.swup }));
  }
  getFragmentVisit(t, e) {
    const n = et(t, this.parsedRules, e || this.swup.createVisit(t));
    if (!n) return;
    const i = ((l, u, p, h) => {
      let d = u.map((c) => {
        const f = document.querySelector(c);
        return f ? q(c, p) ? { selector: c, el: f } : (g && (h == null ? void 0 : h.error(`${w(c)} is outside of swup's default containers`)), false) : (g && (h == null ? void 0 : h.log(`${w(c)} missing in current document`)), false);
      }).filter((c) => !!c);
      const m = d.every((c) => V(c.el, l.to));
      return F(l.from, l.to) || m && p.options.linkToSelf === "navigate" || (d = d.filter((c) => !V(c.el, l.to) || (g && (h == null ? void 0 : h.log(`ignoring fragment ${w(c.selector)} as it already matches the current URL`)), false))), d.map((c) => c.selector);
    })(t, n.containers, this.swup, this.logger);
    if (!i.length) return;
    const { name: r, scroll: s, focus: a } = n;
    return { containers: i, name: r, scroll: s, focus: a };
  }
}
function H() {
  return H = Object.assign ? Object.assign.bind() : function(o) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (o[n] = e[n]);
    }
    return o;
  }, H.apply(this, arguments);
}
class $t extends k {
  constructor(t = {}) {
    super(), this.name = "SwupScriptsPlugin", this.requires = { swup: ">=4" }, this.defaults = { head: true, body: true, optin: false }, this.options = void 0, this.options = H({}, this.defaults, t);
  }
  mount() {
    this.on("content:replace", this.runScripts);
  }
  runScripts() {
    const { head: t, body: e, optin: n } = this.options, i = this.getScope({ head: t, body: e });
    if (!i) return;
    const r = Array.from(i.querySelectorAll(n ? "script[data-swup-reload-script]" : "script:not([data-swup-ignore-script])"));
    r.forEach((s) => this.runScript(s)), this.swup.log(`Executed ${r.length} scripts.`);
  }
  runScript(t) {
    const e = document.createElement("script");
    for (const { name: n, value: i } of t.attributes) e.setAttribute(n, i);
    return e.textContent = t.textContent, t.replaceWith(e), e;
  }
  getScope({ head: t, body: e }) {
    return t && e ? document : t ? document.head : e ? document.body : null;
  }
}
const Q = Y, Et = "cubic-bezier(0.25, 1, 0.5, 1)", Pt = "cubic-bezier(0, 0.55, 0.45, 1)", O = { default: { out: [[{ opacity: 1 }, { opacity: 0, translate: "0 -5px" }], { duration: 200, fill: "forwards", easing: Pt }], in: [[{ opacity: 0, translate: "0 10px" }, { opacity: 1 }], { duration: 400, easing: Et }] } }, Ot = !Y, Ft = new it({ plugins: [...Q ? [new dt()] : [], new lt(), new $t({ head: false, body: true }), ...Ot ? [new ct({ preloadVisibleLinks: { ignore: (o) => o.href.toString().includes("/cart"), delay: 0 } })] : [], new At({ debug: Q, rules: [] }), new pt({ animations: [{ from: "(.*)", to: "(.*)", out: async (o, t) => {
  var _a;
  Lt(t.visit.trigger.el);
  const n = (_a = t.visit.trigger.el) == null ? void 0 : _a.dataset.swupAnimation, r = (n && O[n] || O.default).out, s = t.visit.containers.map((a) => {
    var _a2;
    return (_a2 = document.querySelector(a)) == null ? void 0 : _a2.animate(...r);
  });
  await Promise.all(s.map((a) => a == null ? void 0 : a.finished));
}, in: async (o, t) => {
  var _a;
  const n = (_a = t.visit.trigger.el) == null ? void 0 : _a.dataset.swupAnimation, r = (n && O[n] || O.default).in, s = t.visit.containers.map((a) => {
    var _a2;
    return (_a2 = document.querySelector(a)) == null ? void 0 : _a2.animate(...r);
  });
  await Promise.all(s.map((a) => a == null ? void 0 : a.finished)), _t();
} }] })] });
function Lt(o) {
  if (!o) return;
  const t = o == null ? void 0 : o.dataset.swupScrollBehavior, e = o == null ? void 0 : o.dataset.swupScrollPadding;
  t && (window.document.documentElement.style.scrollBehavior = t), e && (window.document.documentElement.style.scrollPadding = e);
}
function _t() {
  window.document.documentElement.style.removeProperty("scroll-behavior"), window.document.documentElement.style.removeProperty("scroll-padding");
}
export {
  Ft as s
};
